import React, { useEffect, useState } from "react";
import SuccessPage from "./successPage";
import { IconButton } from "@mui/material";
import { SnackbarOrigin } from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import ToastNotification from "../../../../../../components/ToastNotification/ToastNotification";
import FormFields from "./FormFields";
import { resetWebformSubmitStatuses } from "../service/publicwebformSlice";
import { useDispatch } from "react-redux";
import archivedImg from "../components/Assets/archive.svg";

export interface SnackStateProp extends SnackbarOrigin {
  snackOpen: boolean;
  message: string;
  snackSeverity?: "error" | "info" | "success" | "warning";
}

const PublicWebForm = (props: any) => {
  const {
    success,
    loading,
    error,
    contactUpdateSuccess,
    contactUpdateLoading,
    contactUpdateError,
    contactDetails,
    CreateContact,
    GetPublicWebformById,
    publicWebform,
    contactCreateLoading,
    leadPayLink,
  } = props;
  const dispatch = useDispatch();

  const [snackState, setSnackState] = React.useState<SnackStateProp>({
    snackOpen: false,
    vertical: "top",
    horizontal: "right",
    message: "Something went wrong",
    snackSeverity: "info",
  });
  const { vertical, horizontal, snackOpen, message, snackSeverity } =
    snackState;
  const [specialCharacterWarning, setSpecialCharacterWarning] = useState(false);

  React.useEffect(() => {
    if (success) {
      setSnackState((snackState: SnackStateProp) => ({
        ...snackState,
        message: "Details Submitted Successfully",
        snackOpen: true,
        snackSeverity: "success",
      }));
    }
  }, [success]);

  React.useEffect(() => {
    if (error) {
      setSnackState((snackState: SnackStateProp) => ({
        ...snackState,
        message: String(props?.error),
        snackOpen: true,
        snackSeverity: "error",
      }));
    }
  }, [error]);

  // React.useEffect(() => {
  //   if (specialCharacterWarning) {
  //     dispatch(
  //       setToastNotification({
  //         message: "Special Characters not allowed",
  //         type: "error",
  //         snackOpen: true,
  //       })
  //     );
  //   }
  // }, [specialCharacterWarning]);

  const closeSnack = React.useCallback(() => {
    setSnackState({ ...snackState, snackOpen: false });
  }, [snackState]);
  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color={snackSeverity}
      onClick={closeSnack}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
  const [fields, setFields] = useState([]);

  React.useEffect(() => {
    const currentUrl = window.location.href;
    const parts = currentUrl.split("/");
    let lastPart = parts[parts.length - 1];
    lastPart = lastPart.split("?")[0];

    GetPublicWebformById(lastPart);
  }, [GetPublicWebformById]);

  React.useEffect(() => {
    if (publicWebform?.fields?.length > 0) {
      const updatedFields = publicWebform?.fields?.map(
        (item: any, index: number) => ({
          fieldType: item?.fieldType,
          fieldName: item?.fieldName,
          fieldValue: "",
          options: item?.options,
          required: item?.required,
          index: index + 1,
          id: item?.id,
          isValid: true,
          countryCode: "",
          type: item?.type,
        })
      );

      setFields(updatedFields);
    }
  }, [publicWebform]);

  React.useEffect(() => {
    if (success === true && publicWebform?.isCollectPayment) {
      if (
        leadPayLink &&
        typeof leadPayLink === "string" &&
        leadPayLink.trim() !== ""
      ) {
        window.open(leadPayLink, "_blank");

        const timeoutId = setTimeout(() => {
          dispatch(resetWebformSubmitStatuses());
        }, 3000);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [success, leadPayLink, publicWebform]);
  return (
    <>
      <ToastNotification />
      {publicWebform?.status === "ARCHIVED" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          <img
            style={{ maxWidth: "100%" }}
            src={archivedImg}
            alt="archivedImg"
          />
        </div>
      ) : (
        <>
          {success === false && (
            <FormFields
              fields={fields}
              setFields={setFields}
              CreateContact={CreateContact}
              publicWebform={publicWebform}
              contactCreateLoading={contactCreateLoading}
            />
          )}

          {success === true && <SuccessPage />}
        </>
      )}
    </>
  );
};

export default PublicWebForm;
